import React from "react";

const ProjectItemActionsDropdown = ({ project }) => {
  return <div></div>;
};

export default ProjectItemActionsDropdown;
